<template>
    <div>
        <el-dialog
            :visible="value"
            :beforeClose="close"
            v-bind="$attrs"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
            v-on="$listeners"
        >
            <el-row :gutter="0">
                <el-form
                    ref="elForm"
                    :model="formData"
                    :rules="rules"
                    size="small"
                    label-width="100px"
                >
                    <el-col :span="24">
                    <el-form-item
                        label="选项名"
                        prop="label"
                    >
                        <el-input
                        v-model="formData.label"
                        placeholder="请输入选项名"
                        clearable
                        />
                    </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="isData">
                    <el-form-item
                        label="选项值"
                        prop="extraValue"
                    >
                        <el-input
                            v-model="formData.extraValue"
                            placeholder="请输入选项值"
                            clearable
                        >
                        </el-input>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
            <div slot="footer">
                <el-button
                    type="primary"
                    @click="handelConfirm"
                >
                    确定
                </el-button>
                <el-button @click="close">
                    取消
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

function getTreeNodeId () {
    const str = localStorage.getItem('treeNodeId')
    if (str) return parseInt(str, 10)
    return 100
}
export function saveTreeNodeId (id) {
    localStorage.setItem('treeNodeId', `${id}`)
}
  
const id = getTreeNodeId()
  
export default {
    components: {},
    props: {
        formData: {
            default: () => {},
            type: Object,
        },
        isData: {
            default: false,
            type: Boolean,
        },
        value: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            id,
            rules: {
                label: [
                    {
                        required: true,
                        message: '请输入选项名',
                        trigger: 'blur',
                    },
                ],
                extraValue: [
                    {
                        required: true,
                        message: '请输入选项值',
                        trigger: 'blur',
                    },
                ],
            },
            dataType: 'string',
            dataTypeOptions: [
                {
                    label: '字符串',
                    value: 'string',
                },
                {
                    label: '数字',
                    value: 'number',
                },
            ],
        }
    },
    watch: {
        id (val) {
            saveTreeNodeId(val)
        },
    },
    methods: {
        close () {
            this.$emit('input', false)
        },
        handelConfirm () {
            this.$refs.elForm.validate(valid => {
                if (!valid) return
                this.formData.id = this.id++
                this.formData.value = this.formData.label
                this.$emit('commit', this.formData)
                this.close()
            })
        },
    },
}
</script>
  